module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    class: [_vm.inputClass, _vm.checkboxClass, _vm.custom ? 'custom-checkbox' : null]
  }, [_c('input', {
    class: [_vm.custom ? 'custom-control-input' : null],
    attrs: {
      "type": "checkbox",
      "id": _vm._id,
      "name": _vm.name,
      "disabled": _vm.disabled
    },
    domProps: {
      "value": _vm.value,
      "checked": _vm.checked === _vm.value
    },
    on: {
      "change": function($event) {
        _vm.$emit('change', $event.target.checked ? _vm.value : _vm.uncheckedValue)
      }
    }
  }), _vm._v(" "), (_vm.custom) ? _c('span', {
    staticClass: "custom-control-indicator"
  }) : _vm._e(), _vm._v(" "), _c('span', {
    class: [_vm.custom ? 'custom-control-description' : null]
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-22f401dd"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/bootstrap-vue/components/form-checkbox.vue
// module id = 229
// module chunks = 0